import styled from '@emotion/styled';

export const StyledModalContainer = styled.div`
    width: 560px;
    height: 480px;
`;

export const StyledClientCreationForm = styled.div`
    color: ${({ theme }) => theme.color.black200};
    font-family: ${({ theme }): string => theme.font.family};
    font-weight: ${({ theme }) => theme.font.weight.regular};
    font-size: ${({ theme }) => theme.font.size.small};
    padding-bottom: 20px;
`;

export const StyledFormError = styled.div`
    color: ${({ theme }) => theme.color.red300};
    background-color: ${({ theme }) => theme.color.io.destructive100};
    border: 1px solid ${({ theme }) => theme.color.red300};
    border-radius: ${({ theme }) => theme.radius.main};
    font-weight: ${({ theme }) => theme.font.weight.bold};
    font-size: ${({ theme }) => theme.font.size.normal};
    padding: 12px 16px;
    margin-top: 16px;
`;
